import "pixi-spine";
import * as PIXI from "pixi.js";
import {PixiApplication} from "./PixiApplication";

export class CustomSpineAnimation extends PIXI.spine.Spine {

    public BASIC_EVENTS_NAMES = {
        START: "start",
        COMPLETE: "complete",
    };

    constructor(animationName: string) {
        super(PixiApplication.Resources[animationName].spineData);
    }

    public play(animationState: string, loop: boolean = false, startingTime: number = 0): void {
        this.state.setAnimation(0, animationState, loop);
        this.state.tracks[0].trackTime = startingTime;
        this.state.update(0);
        this.lastTime = 0;
    }

    public playThanResolveOnAnimationCompleteAndRemoveAllListeners(animationState: string,
                                                                   startingTime: number = 0): Promise<void> {
        return new Promise<void>((res) => {
            this.play(animationState, false, startingTime);
            this.removeAllListenersMyCopy();
            this.addOnCompleteListener(() => {
                this.removeAllListenersMyCopy();
                res();
            });
        });
    }

    public getSlotContainer(slotName: string, clear: boolean = false): PIXI.Container {
        if (clear) {
            this.slotContainers[this.skeleton.findSlotIndex(slotName)].removeChildren();
        }
        return this.slotContainers[this.skeleton.findSlotIndex(slotName)];
    }

    public addEventListener(eventName: string, listener: Function): void {
        this.state.addListener({
            [eventName]: () => {
                setTimeout(() => {
                    listener();
                }, 0);
            },
        });
    }

    public addOnCompleteListener(listener: Function): void {
        this.state.addListener({
            [this.BASIC_EVENTS_NAMES.COMPLETE]: () => {
                setTimeout(() => {
                    listener();
                }, 0);
            },
        });
    }

    public removeAllListenersMyCopy(): void {
        this.state.listeners = [];
    }
}



// WEBPACK FOOTER //
// ./src/app/CustomSpineAnimation.ts